import React, { Component } from 'react'
import Client from '../Client'
import BlackLoading from '../images/black-loader.gif';
import {Carousel} from 'react-bootstrap';

class MasonryServicesFlashImages extends Component {
  constructor(props) {
    super(props)
    this.state = {
         masonryServicesflashpage:[]
    }
}

componentDidMount(){
    Client.getEntries({
        'content_type': 'masonryServicesFlashImages',

    }).then((entries)=>{
        this.setState({masonryServicesflashpage: entries.items})
    });
}


render() {
  return (
    <>
        {this.state.masonryServicesflashpage.length === 0 ?
              <div align="center"><img src={BlackLoading} alt="Loading..." /></div> :
        <Carousel fade={false}>
          
          {this.state.masonryServicesflashpage.map((item, index) => {
            return(
            <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={item.fields.masonryServicesFlashImagesImg.fields.file.url}
              alt="sam bridge Masonry Services slide"
            />
            <Carousel.Caption>
                <span className="slidefont">{item.fields.masonryServicesFlashImagesTitle}</span>
            </Carousel.Caption>
            </Carousel.Item>
                  )
                  })}
        </Carousel>
        }

    </>
    )
  }
}

export default MasonryServicesFlashImages;
